export default __webpack_public_path__ + "static/spyserp-f3946a286abe9a61cc53b523af9f9f5a.svg";